/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_oscuro.svg'
import {SECCIONES} from "../../Constantes";
import {WhatsApp} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";

const BarraPc = () => {
    const {sCell} = useResponsive()
    const {ir} = useIrRuta()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, pt: 1.5, pb: 2}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 11}}
                >

                    <Grid container size={{xs: 4, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                        <img src={logo} width={250} height={'auto'}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-end', mt: -1.5}}>
                        <Grid
                            container
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >

                            {SECCIONES.map((item, index) => (
                                <Typography
                                    onClick={() => ir(item)}
                                    sx={{
                                        mt: 0.5,
                                        color: '#000',
                                        borderBottom: 2,
                                        borderColor: "#00000000",
                                        fontWeight: 400,
                                        cursor: 'pointer',
                                        transition: 'all .2s ease-in-out',
                                        "&:hover": {
                                            borderColor: "#000000",
                                        }
                                    }}
                                >{item}</Typography>
                            ))}

                            <Button
                                onClick={() => iniciarChatWass({mensaje: 'Hola Centro de conciliacion, quiero mas informacion sobre: Diplomado en conciliación en derecho'})}
                                variant={'text'} startIcon={<WhatsApp/>}
                                sx={{px: 0}}
                            >
                                +57 301 524 3727
                            </Button>

                        </Grid>
                    </Grid>


                </Grid>


            </Grid>


        </Grid>
    )

}
export default BarraPc    